import { render, staticRenderFns } from "./categoryList.vue?vue&type=template&id=5576abd8&scoped=true"
import script from "./categoryList.vue?vue&type=script&lang=js"
export * from "./categoryList.vue?vue&type=script&lang=js"
import style0 from "./categoryList.vue?vue&type=style&index=0&id=5576abd8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5576abd8",
  null
  
)

export default component.exports